<script setup lang="ts">
import { computed, ref } from 'vue'
import DolphinSelector from '@/components/atoms/DolphinSelector.vue'
import {
  type IntroductionMessageConditionFormType,
  validateIntroductionMessageConditionForm,
} from './formSchema'

const props = defineProps<{
  inflowSourceOptions: { text: string; value: string }[]
}>()

const model = defineModel<IntroductionMessageConditionFormType>({
  required: true,
})

const errors = computed(() =>
  validateIntroductionMessageConditionForm(model.value)
)

const invalid = ref<{ inflowSourceId: boolean }>({
  inflowSourceId: false,
})

const validateInflowSouceID = (): void => {
  invalid.value = {
    ...invalid.value,
    inflowSourceId: !!errors.value?.inflowSourceId,
  }
}
</script>

<template>
  <div :class="$style.content">
    <p :class="$style.content__title">友だち追加経路</p>
    <div :class="[$style.content__form, $style.form]">
      <DolphinSelector
        :options="props.inflowSourceOptions"
        v-model="model.inflowSourceId"
        :invalid="invalid.inflowSourceId"
        @blur="validateInflowSouceID"
      />
      <p v-if="errors?.inflowSourceId" :class="$style.form__error">
        {{ errors.inflowSourceId }}
      </p>
    </div>
  </div>
</template>

<style lang="scss" module>
.content {
  &__title {
    font-size: 14px;
    font-weight: 700;
  }

  &__form {
    &:nth-child(n + 2) {
      margin-top: 12px;
    }
  }
}

.form {
  &__error {
    color: $color-caution-accent;
    font-size: 12px;
    font-weight: 700;
    margin-top: 4px;
  }
}
</style>
